import { WorldCountry } from '../types';

export const kenyaData: WorldCountry = {
  code: 'KE',
  name: 'Kenya',
  slug: 'kenya',
  population: 53771296,
  topCities: [
    { name: 'Nairobi', slug: 'nairobi', population: 4397073 },
    { name: 'Mombasa', slug: 'mombasa', population: 1208333 },
    { name: 'Kisumu', slug: 'kisumu', population: 409928 },
    { name: 'Nakuru', slug: 'nakuru', population: 307990 },
    { name: 'Eldoret', slug: 'eldoret', population: 289380 },
    { name: 'Kehancha', slug: 'kehancha', population: 256086 },
    { name: 'Ruiru', slug: 'ruiru', population: 238858 },
    { name: 'Kikuyu', slug: 'kikuyu', population: 233231 },
    { name: 'Kangundo-Tala', slug: 'kangundo-tala', population: 218557 },
    { name: 'Malindi', slug: 'malindi', population: 207253 },
    { name: 'Kitale', slug: 'kitale', population: 163282 },
    { name: 'Machakos', slug: 'machakos', population: 150041 },
    { name: 'Thika', slug: 'thika', population: 139853 },
    { name: 'Meru', slug: 'meru', population: 134204 },
    { name: 'Kericho', slug: 'kericho', population: 132259 },
    { name: 'Nyeri', slug: 'nyeri', population: 119272 },
    { name: 'Garissa', slug: 'garissa', population: 116227 },
    { name: 'Kakamega', slug: 'kakamega', population: 107227 },
    { name: 'Kisii', slug: 'kisii', population: 99796 },
    { name: 'Kilifi', slug: 'kilifi', population: 99548 },
    { name: 'Voi', slug: 'voi', population: 91483 },
    { name: 'Mumias', slug: 'mumias', population: 86583 },
    { name: 'Naivasha', slug: 'naivasha', population: 79852 },
    { name: 'Nyahururu', slug: 'nyahururu', population: 78005 },
    { name: 'Busia', slug: 'busia-ke', population: 76158 },
    { name: 'Kitui', slug: 'kitui', population: 73750 },
    { name: 'Webuye', slug: 'webuye', population: 73126 },
    { name: 'Wote', slug: 'wote', population: 71832 },
    { name: 'Muhoroni', slug: 'muhoroni', population: 68830 },
    { name: 'Embu', slug: 'embu', population: 67373 },
    { name: 'Kimilili', slug: 'kimilili', population: 66252 },
    { name: 'Bungoma', slug: 'bungoma', population: 63650 },
    { name: 'Siaya', slug: 'siaya', population: 59037 },
    { name: 'Nanyuki', slug: 'nanyuki', population: 58721 },
    { name: 'Mariakani', slug: 'mariakani', population: 54562 },
    { name: 'Wajir', slug: 'wajir', population: 54840 },
    { name: 'Lamu', slug: 'lamu', population: 50383 },
    { name: 'Athi River', slug: 'athi-river', population: 50234 },
    { name: 'Taveta', slug: 'taveta', population: 49563 },
    { name: 'Isiolo', slug: 'isiolo', population: 48178 },
    { name: 'Karatina', slug: 'karatina', population: 46829 },
    { name: 'Mandera', slug: 'mandera', population: 45353 },
    { name: 'Lodwar', slug: 'lodwar', population: 48000 },
    { name: 'Marsabit', slug: 'marsabit', population: 41478 },
    { name: 'Moyale', slug: 'moyale', population: 39871 },
    { name: 'Kapenguria', slug: 'kapenguria', population: 38536 },
    { name: 'Migori', slug: 'migori', population: 37459 },
    { name: 'Homa Bay', slug: 'homa-bay', population: 36742 },
    { name: 'Mwingi', slug: 'mwingi', population: 35631 },
    { name: 'Makueni', slug: 'makueni', population: 34728 },
    { name: 'Maua', slug: 'maua', population: 33456 },
    { name: 'Chuka', slug: 'chuka', population: 32198 },
    { name: 'Kapsowar', slug: 'kapsowar', population: 31457 },
    { name: 'Eldama Ravine', slug: 'eldama-ravine', population: 30682 },
    { name: 'Othaya', slug: 'othaya', population: 29741 },
    { name: 'Kiambu', slug: 'kiambu', population: 28659 },
    { name: 'Limuru', slug: 'limuru', population: 27834 },
    { name: 'Kajiado', slug: 'kajiado', population: 26947 },
    { name: 'Kerugoya', slug: 'kerugoya', population: 26152 },
    { name: 'Maralal', slug: 'maralal', population: 25368 },
    { name: 'Awendo', slug: 'awendo', population: 24735 },
    { name: 'Rongo', slug: 'rongo', population: 23941 },
    { name: 'Chogoria', slug: 'chogoria', population: 23186 },
    { name: 'Runyenjes', slug: 'runyenjes', population: 22453 },
    { name: 'Molo', slug: 'molo', population: 21729 },
    { name: 'Oyugis', slug: 'oyugis', population: 20984 },
    { name: 'Kapsabet', slug: 'kapsabet', population: 20251 },
    { name: 'Bomet', slug: 'bomet', population: 19538 },
    { name: 'Sotik', slug: 'sotik', population: 18825 },
    { name: 'Kiminini', slug: 'kiminini', population: 18142 },
    { name: 'Iten', slug: 'iten', population: 17469 },
    { name: 'Turbo', slug: 'turbo-ke', population: 16796 },
    { name: 'Burnt Forest', slug: 'burnt-forest', population: 16134 },
    { name: 'Moi\'s Bridge', slug: 'mois-bridge', population: 15472 },
    { name: 'Kapkatet', slug: 'kapkatet', population: 14821 },
    { name: 'Lugari', slug: 'lugari', population: 14179 },
    { name: 'Kapsokwony', slug: 'kapsokwony', population: 13547 },
    { name: 'Kabarnet', slug: 'kabarnet', population: 12925 },
    { name: 'Kaptagat', slug: 'kaptagat', population: 12314 },
    { name: 'Moi University', slug: 'moi-university', population: 11713 },
    { name: 'Kimilili-Bungoma', slug: 'kimilili-bungoma', population: 11123 },
    { name: 'Sabatia', slug: 'sabatia', population: 10543 },
    { name: 'Malava', slug: 'malava', population: 9973 },
    { name: 'Butere', slug: 'butere', population: 9413 },
    { name: 'Khwisero', slug: 'khwisero', population: 8863 },
    { name: 'Shinyalu', slug: 'shinyalu', population: 8323 },
    { name: 'Teso North', slug: 'teso-north', population: 7793 },
    { name: 'Teso South', slug: 'teso-south', population: 7273 },
    { name: 'Samia', slug: 'samia', population: 6763 },
    { name: 'Bunyala', slug: 'bunyala', population: 6263 },
    { name: 'Butula', slug: 'butula', population: 5773 },
    { name: 'Funyula', slug: 'funyula', population: 5293 },
    { name: 'Nambale', slug: 'nambale', population: 4823 },
    { name: 'Matayos', slug: 'matayos', population: 4363 },
    { name: 'Bumula', slug: 'bumula', population: 3913 },
    { name: 'Kanduyi', slug: 'kanduyi', population: 3473 },
    { name: 'Sirisia', slug: 'sirisia', population: 3043 },
    { name: 'Kabuchai', slug: 'kabuchai', population: 2623 },
    { name: 'Tongaren', slug: 'tongaren', population: 2213 },
    { name: 'Ndivisi', slug: 'ndivisi', population: 1813 },
    { name: 'Cheptais', slug: 'cheptais', population: 1423 },
    { name: 'Chesumei', slug: 'chesumei', population: 1043 },
    { name: 'Keiyo North', slug: 'keiyo-north', population: 673 },
    { name: 'Keiyo South', slug: 'keiyo-south', population: 313 },
    // Nuevas ciudades para Kenya - Expansión a 100 ciudades
    { name: 'Nandi Hills', slug: 'nandi-hills', population: 8500 },
    { name: 'Kapsoya', slug: 'kapsoya', population: 7800 },
    { name: 'Mosoriot', slug: 'mosoriot', population: 7200 },
    { name: 'Chemase', slug: 'chemase', population: 6800 },
    { name: 'Kabiyet', slug: 'kabiyet', population: 6400 },
    { name: 'Cheptiret', slug: 'cheptiret', population: 6000 },
    { name: 'Sangalo', slug: 'sangalo', population: 5600 },
    { name: 'Kabwareng', slug: 'kabwareng', population: 5200 },
    { name: 'Chepkunyuk', slug: 'chepkunyuk', population: 4800 },
    { name: 'Kipkenyo', slug: 'kipkenyo', population: 4400 }
  ]
};
